<div *nzModalTitle class="px-0 py-1 w-full grid grid-cols-2 gap-4 place-content-evenly">
    <div style="display: flex; align-items: center;">
      <p class="modal-title">{{data.nzTitle}}</p>
    </div>
</div>

<div #modalContent class="w-full h-full p-0 m-0">
    @if (isLoading) {
	    <app-loader></app-loader>
	}
	@else{
        @if (packagingTypes && packagingTypes.length > 0) {
            <nz-table
                #packagingTypesTable
                [nzData]="packagingTypes"
                class="m-0 p-0"
                nzSize="small"
                [nzLoading]="isLoading"
                nzTableLayout="auto"
                [nzBordered]="true"
                [nzFrontPagination]="false"
                [nzShowPagination]="false"
                [nzScroll]="{ y: (tableHeight || 0) + 'px' }"
            >
                <thead>
                    <tr>
                        <th></th>
                        <th>Nombre</th>
                        <th>Cantidad por formato</th>
                        <th>Cantidad a producir</th>
                    </tr>
                </thead>
                <tbody>
                    @for (packagingType of packagingTypesTable.data; track packagingType.id; let i = $index) {
                        <tr>
                            <td>
                                <label
                                nz-checkbox
                                [disabled]="justWatching"
                                [ngModel]="selectedPackagingIds.indexOf(packagingType.id || -1) > -1"
                                (nzCheckedChange)="setAsSelected(packagingType.id || -1)"
                                ></label>
                            </td>
                            <td>{{ packagingType.name }}</td>
                            <td>
                                {{ packagingType.quantityPerPackaging }}
                                {{ packagingType.measurementUnit?.abbreviation }}
                                <span class="text-gray-300"> - Cantidad estimada {{ roundUp(remainingQuantityToProduce / packagingType.quantityPerPackaging) }}</span>
                            </td>
                            <td>
                                <input onfocus="select()" nz-input type="number" [disabled]="justWatching" [(ngModel)]="packagingType.quantity" />
                            </td>
                        </tr>
                    }
                </tbody>
            </nz-table>

        }
        @else {
            <div class="w-full h-full content-center">
                <nz-empty></nz-empty>
            </div>
        }
    }
</div>
<div *nzModalFooter>
    <div class="flex justify-end">
        <button
        (click)="handleCancel()"
        class="button secondary-button mr-2"
        >
            Cancelar
        </button>

        <button nz-button class="button primary-button" (click)="save()" [nzLoading]="isSaving">
            Aceptar
        </button>
    </div>
</div>
